export default __webpack_public_path__ + "static/brand-logo-ttp-f674a809a5a00242802b37a66c0c59f7.svg";